<script>
export default {
  name: 'Logout',
  created() {
    this.$auth.logout();
  },
};
</script>
